function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { IF_USER_CREATED_BEFORE_FAILURE, IF_USER_CREATED_BEFORE_REQUEST, IF_USER_CREATED_BEFORE_SUCCESS } from 'swag-client-common/redux/collect-sizes/collect-sizes.actions';
import { CLEAR_SUBMIT_SIZE_EMAIL_ERROR, CREATE_FAILURE, CREATE_REQUEST, CREATE_SUCCESS, DELETE_SIZE_SUBMISSION_ERROR, DELETE_SIZE_SUBMISSION_REQUEST, DELETE_SIZE_SUBMISSION_SUCCESS, ERASE_SIZE_SUBMISSION_CARDS, GET_SIZE_SUBMISSION_CARDS_ERROR, GET_SIZE_SUBMISSION_CARDS_REQUEST, GET_SIZE_SUBMISSION_CARDS_SUCCESS, GET_SIZE_SUBMISSION_LINK_DATA_ERROR, GET_SIZE_SUBMISSION_LINK_DATA_REQUEST, GET_SIZE_SUBMISSION_LINK_DATA_SUCCESS, MOVE_TO_POPUP_NEXT_STEP, RENAME_SIZE_SUBMISSION_ERROR, RENAME_SIZE_SUBMISSION_REQUEST, RENAME_SIZE_SUBMISSION_SUCCESS, RESET_POPUP_WIZARD, SUBMIT_SIZE_ERROR, SUBMIT_SIZE_REQUEST, SET_SUCCESSFULLY_SUBMIT_SIZE } from './collect-sizes.actions';
export const DEFAULT_SIZE_SUBMISSIONS_PER_PAGE = 12;
export let WIZARD_STEPS = /*#__PURE__*/function (WIZARD_STEPS) {
  WIZARD_STEPS["GREETINGS"] = "GREETINGS";
  WIZARD_STEPS["COLLECTION_NAME"] = "COLLECTION_NAME";
  WIZARD_STEPS["GENERATED_LINK"] = "GENERATED_LINK";
  return WIZARD_STEPS;
}({});
const POPUP_WIZARD_STEP_ORDER = [WIZARD_STEPS.GREETINGS, WIZARD_STEPS.COLLECTION_NAME, WIZARD_STEPS.GENERATED_LINK];
const initialState = {
  isUserCreatedCollectSizesBefore: false,
  loading: false,
  link: '',
  step: WIZARD_STEPS.GREETINGS,
  isSizeSubmissionsLoading: false,
  isSuccessfullySubmitted: false,
  sizeSubmissionPagination: {
    page: 0,
    total: 0,
    perPage: DEFAULT_SIZE_SUBMISSIONS_PER_PAGE
  },
  sizeSubmissions: {
    ids: [],
    data: {}
  },
  campaign: {
    email: '',
    company: '',
    firstName: '',
    lastName: '',
    link: '',
    linkOpened: 0,
    name: '',
    product: null,
    mockup: null,
    sizeOptions: [],
    userId: '',
    _id: ''
  },
  submitSizeEmailError: ''
};
export const collectSizesReducer = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case IF_USER_CREATED_BEFORE_REQUEST:
    case GET_SIZE_SUBMISSION_LINK_DATA_REQUEST:
    case SUBMIT_SIZE_REQUEST:
    case CREATE_REQUEST:
      {
        return _objectSpread({}, state, {
          loading: true
        });
      }
    case IF_USER_CREATED_BEFORE_SUCCESS:
      {
        const isUserCreatedCollectSizesBefore = payload.isUserCreatedCollectSizesBefore;
        return _objectSpread({}, state, {
          isUserCreatedCollectSizesBefore,
          step: isUserCreatedCollectSizesBefore ? WIZARD_STEPS.COLLECTION_NAME : WIZARD_STEPS.GREETINGS,
          loading: false
        });
      }
    case CREATE_SUCCESS:
      {
        return _objectSpread({}, state, {
          link: payload.link,
          isUserCreatedCollectSizesBefore: true,
          loading: false
        });
      }
    case IF_USER_CREATED_BEFORE_FAILURE:
    case GET_SIZE_SUBMISSION_LINK_DATA_ERROR:
    case CREATE_FAILURE:
      {
        return _objectSpread({}, state, {
          loading: false
        });
      }
    case SUBMIT_SIZE_ERROR:
      {
        var _payload$error$messag, _payload$error;
        return _objectSpread({}, state, {
          loading: false,
          submitSizeEmailError: /(email|e-mail)/i.test((_payload$error$messag = (_payload$error = payload.error) === null || _payload$error === void 0 ? void 0 : _payload$error.message) !== null && _payload$error$messag !== void 0 ? _payload$error$messag : '') ? payload.error.message : ''
        });
      }
    case CLEAR_SUBMIT_SIZE_EMAIL_ERROR:
      {
        return _objectSpread({}, state, {
          submitSizeEmailError: ''
        });
      }
    case MOVE_TO_POPUP_NEXT_STEP:
      {
        const currentStepIndex = POPUP_WIZARD_STEP_ORDER.indexOf(state.step);
        const newStep = POPUP_WIZARD_STEP_ORDER[currentStepIndex + 1];
        if (newStep) {
          return _objectSpread({}, state, {
            step: newStep
          });
        }
      }
    case RESET_POPUP_WIZARD:
      {
        return _objectSpread({}, state, {
          step: state.isUserCreatedCollectSizesBefore ? WIZARD_STEPS.COLLECTION_NAME : WIZARD_STEPS.GREETINGS
        });
      }
    case RENAME_SIZE_SUBMISSION_REQUEST:
    case GET_SIZE_SUBMISSION_CARDS_REQUEST:
    case DELETE_SIZE_SUBMISSION_REQUEST:
      {
        return _objectSpread({}, state, {
          isSizeSubmissionsLoading: true
        });
      }
    case GET_SIZE_SUBMISSION_CARDS_SUCCESS:
      {
        var _payload$pagination$p, _payload$pagination$t;
        const {
          newIds,
          newData
        } = payload.list.reduce((acc, sizeSub) => {
          acc.newIds.push(sizeSub._id);
          acc.newData[sizeSub._id] = sizeSub;
          return acc;
        }, {
          newIds: [],
          newData: {}
        });
        return _objectSpread({}, state, {
          isSizeSubmissionsLoading: false,
          sizeSubmissionPagination: _objectSpread({}, state.sizeSubmissionPagination, {
            page: (_payload$pagination$p = payload.pagination.page) !== null && _payload$pagination$p !== void 0 ? _payload$pagination$p : 0,
            total: (_payload$pagination$t = payload.pagination.total) !== null && _payload$pagination$t !== void 0 ? _payload$pagination$t : 0
          }),
          sizeSubmissions: _objectSpread({}, state.sizeSubmissions, {
            ids: [...state.sizeSubmissions.ids, ...newIds],
            data: _objectSpread({}, state.sizeSubmissions.data, newData)
          })
        });
      }
    case DELETE_SIZE_SUBMISSION_SUCCESS:
      {
        const newData = {};
        for (const key in state.sizeSubmissions.data) {
          if (key !== payload) {
            newData[key] = state.sizeSubmissions.data[key];
          }
        }
        return _objectSpread({}, state, {
          isSizeSubmissionsLoading: false,
          sizeSubmissionPagination: _objectSpread({}, state.sizeSubmissionPagination, {
            total: state.sizeSubmissionPagination.total - 1
          }),
          sizeSubmissions: _objectSpread({}, state.sizeSubmissions, {
            ids: state.sizeSubmissions.ids.filter(oldId => oldId !== payload),
            data: newData
          })
        });
      }
    case RENAME_SIZE_SUBMISSION_ERROR:
    case GET_SIZE_SUBMISSION_CARDS_ERROR:
    case DELETE_SIZE_SUBMISSION_ERROR:
      {
        return _objectSpread({}, state, {
          isSizeSubmissionsLoading: false
        });
      }
    case ERASE_SIZE_SUBMISSION_CARDS:
      {
        return _objectSpread({}, state, {
          isSizeSubmissionsLoading: false,
          sizeSubmissionPagination: initialState.sizeSubmissionPagination,
          sizeSubmissions: initialState.sizeSubmissions
        });
      }
    case GET_SIZE_SUBMISSION_LINK_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          loading: false,
          campaign: _objectSpread({}, state.campaign, payload.campaign)
        });
      }
    case RENAME_SIZE_SUBMISSION_SUCCESS:
      {
        const newData = {};
        for (const key in state.sizeSubmissions.data) {
          newData[key] = key === payload._id ? _objectSpread({}, state.sizeSubmissions.data[key], payload) : state.sizeSubmissions.data[key];
        }
        return _objectSpread({}, state, {
          isSizeSubmissionsLoading: false,
          sizeSubmissions: _objectSpread({}, state.sizeSubmissions, {
            data: newData
          })
        });
      }
    case SET_SUCCESSFULLY_SUBMIT_SIZE:
      {
        return _objectSpread({}, state, {
          isSuccessfullySubmitted: payload
        });
      }
    default:
      {
        return state;
      }
  }
};